import styled from 'styled-components';
const UBISOFT_BLUE = '#428ee0'
const TABLET_BREAKPOINT = '1475px';
const MIN_TABLET_BREAKPOINT = '850px';
const SELECTORS = ''

interface INavigationStyle {
  isCurrentPage: boolean;
}

export const Navigation = styled.div`
    ${SELECTORS} & {
      padding-top: 50px;
    }
    @media (max-width: ${MIN_TABLET_BREAKPOINT}) { 
       ${SELECTORS} & {
         padding-top: 0;
       }
   }
`;

export const NavigationContainer = styled.div`
    ${SELECTORS} & {
      width: 80%;
      max-width: 1380px;
      margin: 0 auto 70px auto;
      background-color: #3C4145;
      border-radius: 15px;
      display: flex;
      flex-wrap: wrap;
      height: 100px;
    }
    svg{
        display: block;
        width: 175px;
        height: 28px;
        margin: auto 0 auto 40px;
         
    } 
   @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
          height: 60px;
        }
        svg{
          height: 15px;
          width: 87.5px;
        }
   }
   @media (max-width: ${MIN_TABLET_BREAKPOINT}) { 
       ${SELECTORS} & {
         width: 100%;
         border-radius: 0;
         overflow: auto;
         white-space: nowrap;
         margin-top: 0;
         .navigation-logo{
            display: none;
         }
       }
   }
   
`;

export const NavigationLineSeparator = styled.div`
    ${SELECTORS} & {
        height: 65%;
        width: 4px;
        background-color: white;
        margin: auto 50px;
    }
    @media (max-width: ${MIN_TABLET_BREAKPOINT}) { 
        ${SELECTORS} & {
            display: none;   
        }
    }
`;

export const NavigationItemsContainer = styled.div`
    ${SELECTORS} & {
      margin : 37.5px 0 37.5px 0;
    }
    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            margin: auto 0;
         }
      }
`;

export const NavigationItem = styled.a`
    ${SELECTORS} & {
      position: relative;
        font-size: 21px;
        font-weight: bold;
        margin: auto 60px auto 0px;
        text-decoration: none;
        font-family: "Ubisoft Sans Regular", Arial, sans-serif;
        font-style: normal;
        line-height: 25px;
        text-align: center;
        text-transform: uppercase;
    }
    
    color : ${({ isCurrentPage }: INavigationStyle) => isCurrentPage ? UBISOFT_BLUE : 'white'} ;
    
    &:hover {
       color: ${UBISOFT_BLUE};
    }
    
    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
          font-size: 18px;
          margin: auto 20px auto 0;
          &:before {
            bottom: -20px !important;
          }
        }
    }
    
    @media (max-width: ${MIN_TABLET_BREAKPOINT}) { 
          ${SELECTORS} & {
              margin: auto 10px auto 10px;   
          }
    }
   
    ${({ isCurrentPage }: INavigationStyle) => isCurrentPage ? `
        &:before {
        content: '';
        position: absolute;
        right: -30px;
        bottom: -37px;
        left: -30px;
        border-bottom: 4px solid ${UBISOFT_BLUE};
        width: 100%;
        margin: auto;
    }
    ` : ''};
    
    &:hover {
       &:before {
        content: '';
        position: absolute;
        right: -30px;
        bottom: -37px;
        left: -30px;
        width: 100%;
        border-bottom: 4px solid ${UBISOFT_BLUE};
        margin: auto;
    }
    }
`;

export const NavigationSubscriptionButton = styled.div`
   ${SELECTORS} & {
        margin: auto 40px auto auto;
   }
   @media (max-width: ${TABLET_BREAKPOINT}) {
        display: none;
    }
`;